import React, { useMemo, useState, useEffect } from 'react';
import { Card, Col, Row, Button } from 'react-bootstrap';
import PageTitle from '../../includes/PageTitle';
import Tables from "../../components/Tables/Tables";
import Modals from "../../components/Modals/Modals";
import Alert from 'react-bootstrap/Alert';
import SelectFild from '../../components/SelectFild/SelectFild';
import { useFormik } from 'formik';
import { ToastContainer, toast } from 'react-toastify';
import Loader from '../../components/Loader/Loader';
import EmailTemplateMaster from './EmailTemplateMaster';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import {
    ClassicEditor,
    Essentials,
    Paragraph,
    Heading,
    Bold,
    Italic,
    Underline,
    Strikethrough,
    Code,
    Subscript,
    Superscript,
    Font,
    FontFamily,
    FontSize,
    FontColor,
    FontBackgroundColor,
    Alignment,
    Link,
    List,
    TodoList,
    BlockQuote,
    Indent,
    IndentBlock,
    Table,
    TableToolbar,
    TableProperties,
    TableCellProperties,
    HorizontalLine,
    RemoveFormat,
    SpecialCharacters,
    SourceEditing,
    GeneralHtmlSupport,
    Undo
} from 'ckeditor5';
import { postCommonMaster, postEmailTemplate, getEmailTemplate, postEmailTemplateSave, deleteEmailTemplate, postDocumentFileList } from '../../apiservices/ApiServices';
import { FaFilePdf, FaEye } from "react-icons/fa";

const MailTemplates = () => {
    const [isLoading, setLoading] = useState(false);
    const [isLoadings, setLoadings] = useState(false);
    const [show, setShow] = useState(false);
    const [addModal, setAddModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [isActive, setIsActive] = useState(false);
    const [data, setData] = useState([]);
    const [emailBody, setEmailBody] = useState('');
    const [commonMaster, setCommonMaster] = useState([]);

    const [selectedDocument, setSelectedDocument] = useState([]);
    const [documentListData, setDocumentListData] = useState([]);

    const postEmailTemplates = async (postData) => {
        setLoading(true);
        try {
            const res = await postEmailTemplate(postData);
            setData(res?.data?.data?.records);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const postUpdates = async () => {
        let postData = {
            length: 100
        }
        setLoadings(true);
        try {
            const res = await postEmailTemplate(postData);
            setData(res?.data?.data?.records);
            setLoadings(false);
        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    useEffect(() => {
        let postData = {
            length: 100
        }
        postEmailTemplates(postData);
    }, []);

    const columns = useMemo(
        () => [
            {
                Header: "Template Code",
                accessor: "template_code",
            },
            {
                Header: "Template Name",
                accessor: "template_name",
            },
            {
                Header: "Email Subject",
                accessor: "email_subject",
            },
            {
                Header: "Action",
                accessor: "action",
                disableSortBy: true,
            },
        ],
        []
    );

    const actions = ['edit', 'delete']
    const subActions = []

    const initialValues = {
        id: '',
        tmpName: '',
        templateCode: '',
        billingEntityId: '',
        emailSubject: '',
    }

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: '',
        onSubmit: async (values) => {
            setLoadings(true);
            let postData = {
                template_id: values.id,
                template_code: values.templateCode,
                template_name: values.tmpName,
                email_subject: values.emailSubject,
                email_body: emailBody,
                billing_entity_id: values.billingEntityId,
                document_file_ids: selectedDocument,
            }
            try {
                const res = await postEmailTemplateSave(postData);
                toast.success(res.data.message);
                postUpdates();
                setAddModal(false);
                setIsEdit(false);
                setLoadings(false);
                formik.resetForm();
            } catch (error) {
                setLoadings(false);
                toast.error(error.response?.data?.message || "Error submitting data");
            }
        },
    });
    const { values, handleChange, handleBlur, handleSubmit, setFieldValue, errors, touched } = formik;

    const handleConfirm = () => {
        setAddModal(false);
        setIsEdit(false);
        formik.resetForm();
    };

    const addnew = async () => {
        formik.resetForm();
        setSelectedDocument([]);
        setDocumentListData([]);
        setEmailBody('');
        setLoadings(true);
        setIsEdit(false);

        let postData = {
            type: [
                "billing_entity",
            ],
            org_type_code: ''
        }
        try {
            const res = await postCommonMaster(postData);
            setCommonMaster(res.data.data);
            setLoadings(false);
            setAddModal(true);

        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const handleEdit = async (rowData) => {
        formik.resetForm();
        setLoadings(true);
        setEmailBody([]);
        let postData = {
            type: [
                "billing_entity",
            ],
            org_type_code: ''
        }
        try {
            const ress = await postCommonMaster(postData);
            setCommonMaster(ress.data.data);
            try {
                const res = await getEmailTemplate(rowData?.template_id);
                setFieldValue('id', res.data.data?.template_id);
                setFieldValue('tmpName', res.data.data?.template_name);
                setFieldValue('templateCode', res.data.data?.template_code);
                setFieldValue('billingEntityId', res.data.data.billing_entity?.org_id);
                setFieldValue('emailSubject', res.data.data?.email_subject);
                setEmailBody(res.data.data?.email_body);
                setSelectedDocument(res.data.data?.document_file_ids);


                setLoadings(false);
                setIsEdit(true);
                setAddModal(true);
            } catch (error) {
                setLoadings(false);
                setIsEdit(false);
                setAddModal(false);
            }
        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const handleDelete = (rowData) => {
        setShow(true);
        setFieldValue('id', rowData.template_id);
        setFieldValue('tmpName', rowData.template_name);
    };

    const handleDeleteCon = async () => {
        setLoadings(true);
        try {
            const res = await deleteEmailTemplate(values.id);
            toast.success(res.data.message);
            setLoadings(false);
            setShow(false);
            postUpdates();
            setFieldValue('id', '');
            setFieldValue('tmpName', '');
        } catch (error) {
            setLoadings(false);
            setShow(false);
        }
    };
    const postDocumentFileLists = async (postData) => {
        setLoadings(false);
        try {
            const res = await postDocumentFileList(postData);
            setDocumentListData(res.data.data);
            setLoadings(false);
        } catch (error) {
            toast.error(error.response?.data?.message || "Error submitting data");
            setLoadings(false);
        }
    };
    useEffect(() => {
        if (addModal) {
            setLoadings(false);
            let postData = {
                billing_entity_id: values.billingEntityId,
            }
            postDocumentFileLists(postData);

        }
    }, [values?.billingEntityId]);

    // const handleSwitchToggle = (id) => {
    //     setData(prev => prev.map(data =>
    //         data.id === id
    //             ? { ...data, isActive: data.isActive === 1 ? 0 : 1 }
    //             : data
    //     ));
    // };

    return (
        <>
            <ToastContainer
                position="top-right"
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                style={{ zIndex: 9999999999, position: 'fixed' }}
            />
            {isLoading ? <Loader /> :
                <>
                    <PageTitle titles="Invoices" active="Invoices" items={['Home']} />
                    <Row>
                        <Col sm={12} className="col-12">
                            <Card>
                                <Card.Body className="example1-table">
                                    <div className='custompageHed'>
                                        <Row>
                                            <Col md={6}>
                                                <div className='pagetitle_hed'>
                                                    <h1>Mail Templates</h1>
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className='w-100 d-flex justify-content-end'>
                                                    <button type='button' className='btn btn-primary' onClick={() => addnew()}>Add New</button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                    <Tables
                                        columns={columns}
                                        data={data}
                                        actions={actions}
                                        subActions={subActions}
                                        onEdit={handleEdit}
                                        onDelete={handleDelete}
                                    //onSwitchToggle={handleSwitchToggle}
                                    />
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </>
            }

            <Modals
                show={addModal}
                handleClose={() => setAddModal(false)}
                title={isEdit ? 'Edit' : 'Add New'}
                textColor='#000'
                size='xl emtep'
                centered={true}
                backdrop={true}
                onConfirm={handleConfirm}
            >
                <form onSubmit={handleSubmit} autoComplete="off">
                    <Row>
                        <Col md={4}>
                            <div className="form-group">
                                <label className="form-label">Template Name</label>
                                <input
                                    type='text'
                                    id="tmpName"
                                    name="tmpName"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.tmpName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.tmpName && touched.tmpName && (
                                    <p className="errormsg">{errors.tmpName}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="form-group">
                                <label className="form-label">Template Code</label>
                                <input
                                    type='text'
                                    id="templateCode"
                                    name="templateCode"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.templateCode}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.templateCode && touched.templateCode && (
                                    <p className="errormsg">{errors.templateCode}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="form-group">
                                <label className="form-label">Billing Entity</label>
                                <SelectFild
                                    Firstop='Select Billing Entity'
                                    selectName="billingEntityId"
                                    options={commonMaster?.billing_entity}
                                    value={values.billingEntityId}
                                    onChange={(selectedOption) => setFieldValue("billingEntityId", selectedOption?.value || "")}
                                    onBlur={handleBlur}
                                />
                                {errors.billingEntityId && touched.billingEntityId && (
                                    <p className="errormsg">{errors.billingEntityId}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="form-group">
                                <label className="form-label">Email Subject</label>
                                <input
                                    type='text'
                                    id="emailSubject"
                                    name="emailSubject"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.emailSubject}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.emailSubject && touched.emailSubject && (
                                    <p className="errormsg">{errors.emailSubject}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="form-group">
                                <label className="form-label">Email Body</label>
                                <CKEditor
                                    editor={ClassicEditor}
                                    data={emailBody}
                                    config={{
                                        licenseKey: 'GPL',
                                        plugins: [
                                            Essentials,
                                            Paragraph,
                                            Heading,
                                            Bold,
                                            Italic,
                                            Underline,
                                            Strikethrough,
                                            Code,
                                            Subscript,
                                            Superscript,
                                            Font,
                                            FontFamily,
                                            FontSize,
                                            FontColor,
                                            FontBackgroundColor,
                                            Alignment,
                                            Link,
                                            List,
                                            TodoList,
                                            BlockQuote,
                                            Indent,
                                            IndentBlock,
                                            Table,
                                            TableToolbar,
                                            TableProperties,
                                            TableCellProperties,
                                            HorizontalLine,
                                            RemoveFormat,
                                            SpecialCharacters,
                                            SourceEditing,
                                            GeneralHtmlSupport
                                        ],

                                        toolbar: [
                                            'undo', 'redo',
                                            '|',
                                            'heading',
                                            '|',
                                            'fontFamily',
                                            'fontSize',
                                            'fontColor',
                                            'fontBackgroundColor',
                                            '|',
                                            'bold',
                                            'italic',
                                            'underline',
                                            'strikethrough',
                                            '|',
                                            'alignment',
                                            '|',
                                            'bulletedList',
                                            'numberedList',
                                            'todoList',
                                            '|',
                                            'outdent',
                                            'indent',
                                            '|',
                                            'link',
                                            'insertTable',
                                            '|',
                                            'blockQuote',
                                            'horizontalLine',
                                            'removeFormat',
                                            '|',
                                            'sourceEditing'
                                        ],

                                        table: {
                                            contentToolbar: [
                                                'tableColumn',
                                                'tableRow',
                                                'mergeTableCells',
                                                'tableProperties',
                                                'tableCellProperties'
                                            ]
                                        },

                                        htmlSupport: {
                                            allow: [
                                                {
                                                    name: /.*/,
                                                    attributes: true,
                                                    classes: true,
                                                    styles: true
                                                }
                                            ]
                                        }
                                    }}
                                    onChange={(event, editor) => {
                                        const data = editor.getData();
                                        setEmailBody(data);
                                    }}
                                    onReady={(editor) => {
                                        console.log('Editor is ready to use!', editor);
                                    }}
                                    onBlur={(event, editor) => {
                                        console.log('Blur.', editor);
                                    }}
                                    onFocus={(event, editor) => {
                                        console.log('Focus.', editor);
                                    }}
                                />
                            </div>
                        </Col>
                        {documentListData?.common_document?.length > 0 && (
                            <Col md={12}>
                                <div className='fieldsets'>
                                    <div className='fieldsets-title'>Common Document</div>
                                    <div className='attachmentsList'>
                                        <ul>
                                            {documentListData?.common_document?.map((item) => (
                                                <li>
                                                    <div className='listcards'>
                                                        <h4>{item?.document_title}</h4>
                                                        <ul>
                                                            {item?.files?.map((files) => (
                                                                <li>
                                                                    <div className='attBox'>
                                                                        <div className="chkBox">
                                                                            <input
                                                                                type="checkbox"
                                                                                value={files.document_file_id}
                                                                                checked={selectedDocument.includes(files.document_file_id)}
                                                                                onChange={(e) => {
                                                                                    const id = files.document_file_id;
                                                                                    setSelectedDocument(prev =>
                                                                                        e.target.checked
                                                                                            ? [...prev, id]
                                                                                            : prev.filter(pid => pid !== id)
                                                                                    );
                                                                                }}
                                                                            />
                                                                        </div>
                                                                        <div className="pdf-icon">
                                                                            <FaFilePdf size={16} color="#e74c3c" />
                                                                        </div>
                                                                        <p>{files?.file_name}</p>
                                                                        <a href={files?.file_url} target="_blank" className='btn btn-primary' rel="noopener noreferrer"><FaEye /></a>
                                                                    </div>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </Col>
                        )}
                    </Row>
                    <div className='modalfooters'>
                        <div className='button-boxs grid'>
                            <button type="submit" className='btn btn-primary'>Save</button>
                            <button type="button" onClick={handleConfirm} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </form>
            </Modals>

            {show ? (<>
                <Alert variant="danger" onClose={() => setShow(false)} dismissible>
                    <Alert.Heading>Are you sure want to Delete <span>{values.tmpName}</span>  Templates?</Alert.Heading>
                    <hr />
                    <div className='button-boxs grid'>
                        <div>
                            <button onClick={() => handleDeleteCon()} className='btn btn-primary'>OK</button>
                        </div>
                        <div>
                            <button onClick={() => setShow(false)} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </Alert>
                <div className='overly'></div>
            </>) : null}

            {isLoadings && <Loader />}
        </>
    )

}

export default MailTemplates